app.switch = {
    settings: {
        $wrapper: $('[data-switch]'),
    },

    init: function() {
        if( app.switch.settings.$wrapper.length > 0 ) {
        	app.switch.settings.$wrapper.find('.switch__button').on('click', function(){
        		if( ! $(this).hasClass('switch__button--active') ) {
        			$('.switch__button').removeClass('switch__button--active');
        			$(this).addClass('switch__button--active');
        		}
        	});
        }
    },

    select: function() {
        
    }
};